<div class="d-flex flex-column gap-2">
  <div class="d-flex justify-content-around text-center flex-wrap gap-2">
    <div>
      <img src="/assets/svgs/socialNet/telegram_logo_icon_256772.svg"  style="width: 72px; height: 72px;" />
      <p class="pt-4">Телеграм</p>
    </div>
    <div>
      <img src="/assets/svgs/socialNet/facebook_logo_icon_256791.svg" style="width: 72px; height: 72px;" />
      <p class="pt-4">Фейсбук</p>
    </div>
    <div>
      <img src="/assets/svgs/socialNet/tiktok_logo_icon_256777%20(1).svg"  style="width: 72px; height: 72px;"/>
      <p class="pt-4">Тік Ток</p>
    </div>
    <div>
      <img src="/assets/svgs/socialNet/youtube_logo_icon_256801.svg" style="width: 72px; height: 72px;" />
      <p class="pt-4">Ютуб</p>
    </div>
    <div>
      <img src="/assets/svgs/socialNet/mail_google_gmail_logo_icon_256815.svg" style="width: 72px; height: 72px;" />
      <p class="pt-4">{{'mail'| translate}}</p>
    </div>
    <div>
      <img src="/assets/svgs/socialNet/viber_logo_icon_256817.svg" style="width: 72px; height: 72px;" />
      <p class="pt-4">{{'phone'| translate}}</p>
    </div>
  </div>

</div>
